import { useState, useEffect } from 'react';
import React from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardHeader, Collapse, Spinner } from 'reactstrap';
import { FaPlus, FaTrash, FaChevronUp, FaChevronDown, FaUpload } from 'react-icons/fa';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip"; import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";
const getBase64 = (file) => {
    return new Promise(resolve => {
        let baseURL = "";
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
};
const PhotosWithDetails = ({ refid, uploadType, open, showArrow, cardClass, headerClass1, headerClass2, header }) => {
    const roleName = localStorage.getItem("roleName");
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    if (cardClass === undefined) {
        cardClass = "my-4 card-header-click card-header";
    }
    if (headerClass1 === undefined) {
        headerClass1 = "";
    }
    if (headerClass2 === undefined) {
        headerClass2 = "card-header d-flex justify-content-between align-items-center";
    }
    const [isOpen, setIsOpen] = useState(open);
    const [formErrors, setFormErrors] = useState([]);
    const [isIconUp, setIsIconUp] = useState(false);
    const [saving, setSaving] = useState('');
    const [loading, setLoading] = useState(true);
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [documentUploadList, setDocumentUploadList] = useState([]);
    const [deleteDocumentPopup, setDeleteDocumentPopup] = useState({ showDeleteDocumentPopup: false, itemId: 0, date: '', daetails: '', fileName: '' });
    let inputFile = [];

    const toggle = () => {
        setIsOpen(!isOpen);
        setIsIconUp(!isIconUp);
    };

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        if (refid != 0) {
            try {
                const response = await apiGet(
                    '/api/upload/GetUploadedImagesWithDetail/', {
                    params: { Id: refid, UploadType: uploadType, FarmId: farmId }
                }
                );
                if (response.data.status) {
                    setDocumentUploadList(response.data.content);
                    let tempErrors = [];
                    response.data.content.forEach(function (element) {
                        const error = {
                            fileError: ''
                        };
                        tempErrors.push(error);
                    });
                    setFormErrors(tempErrors);
                }

            } catch (err) {
                console.log(err);
            }
        }
        setLoading(false);
    }

    const handleRecordRowsAddRow = () => {
        const item = {
            createdDate: getParsedDate1(new Date()),
            imageDetail: "", id: 0, imageName: '', ImagePhysicalName: '', imagePath: '', imageRelativePath: ''
        };
        const error = {
            fileError: ''
        };
        setFormErrors([...formErrors, error]);
        setDocumentUploadList([...documentUploadList, item]);
    };

    const handleRecordRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...documentUploadList]
        const tempErrors = [...formErrors];
        tempRows.splice(idx, 1)
        tempErrors.splice(idx, 1)
        setDocumentUploadList(tempRows);
        setFormErrors(tempErrors);
    }

    const handleRecordRowsSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        const tempErrors = [...formErrors];
        var errorFound = false;
        let tempRecordUploadList = [...documentUploadList];
        let form = {
            ReferenceId: refid,
            FarmId: farmId,
            UploadType: uploadType,
            userId: userId,
            Images: []
        }
        for (var i = 0; i < tempRecordUploadList.length; i++) {
            var obj = {};
            obj.Id = tempRecordUploadList[i].id;
            obj.imageDetail = tempRecordUploadList[i].imageDetail;
            if (obj.imageDetail == undefined || obj.imageDetail == null || obj.imageDetail == '') {
                tempErrors[i].imageDetail = 'This is mandatory';
                errorFound = true;
            }
            else {
                tempErrors[i].imageDetail = '';
            }
            obj.imageName = tempRecordUploadList[i].imageName;
            if (obj.imageName == undefined || obj.imageName == null || obj.imageName == '') {
                tempErrors[i].fileError = 'This is mandatory';
                errorFound = true;
            }
            else {
                tempErrors[i].fileError = '';
            }
            obj.imagePhysicalName = tempRecordUploadList[i].imagePhysicalName;
            obj.imagePath = tempRecordUploadList[i].imagePath;
            obj.UploadDateText = tempRecordUploadList[i].uploadDate != null ? tempRecordUploadList[i].uploadDateText : "";
            if (obj.UploadDateText == undefined || obj.UploadDateText == null || obj.UploadDateText == '') {
                tempErrors[i].uploadDate = 'This is mandatory';
                errorFound = true;
            }
            else {
                tempErrors[i].uploadDate = '';
            }
            form.Images.push(obj);
        }
        setFormErrors(tempErrors);
        if (!errorFound) {
            const response = await apiPost(
                '/api/upload/SaveImages/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                if (response.data.status) {
                    toast.success("Images Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    setSaving(false);
                    setTimeout(() => {
                        setDocumentUploadList(response.data.content);
                        let tempErrors = [];
                        setFormErrors(tempErrors);
                        response.data.content.forEach(function (element) {
                            const error = {
                                fileError: ''
                            };
                            tempErrors.push(error);
                        });
                        setFormErrors(tempErrors);
                    }, 2000);
                }
            }
        }
        else {
            setSaving(false);
            return false;
        }
    };

    function handleRecordPopupClose() {
    }

    function deleteRecord() {

    }

    const handleDateChange = (idx, date) => {
        const tempRows = [...documentUploadList];
        tempRows[idx].uploadDateText = getParsedDate(date);
        tempRows[idx].uploadDate = getDateFromString(getParsedDate(date));
        setDocumentUploadList(tempRows);
    };

    const getParsedDate1 = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }

    const handleDetailsChange = idx => e => {
        const tempRows = [...documentUploadList];
        tempRows[idx].imageDetail = e.target.value;
        setDocumentUploadList(tempRows);
    };

    const handleRecordChange = async (e, idx) => {
        e.preventDefault();
        const tempErrors = [...formErrors];
        let reader = new FileReader();
        let file = e.target.files[0];
        const errors = {};
        if (file.type != 'image/png' && file.type != 'image/jpeg' && file.type != 'image/jpg') {
            errors.fileError = "Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.";
            tempErrors[idx].fileError = "Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.";
        }
        else if ((file.size / (1024 * 1024)) > 5) {
            errors.fileError = "Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.";
            tempErrors[idx].fileError = "Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.";
        }
        else {
            tempErrors[idx].fileError = "";
        }
        setFormErrors(tempErrors);
        if (Object.keys(errors).length == 0) {
            getBase64(file)
                .then(result => {
                    let form = {
                        FileName: file.name.replace(/\.[^/.]+$/, ""),
                        Type: uploadType,
                        Base64Image: result,
                        RefId: refid,
                        userId: userId
                    }
                    const response = apiPost(
                        '/api/upload/UploadImage/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        }).then(res => {
                            if (res.data != null) {
                                if (res.data.status) {
                                    const tempRows = [...documentUploadList];
                                    tempRows[idx].imageName = res.data.content.ImageName;
                                    tempRows[idx].imagePhysicalName = res.data.content.ImagePhysicalName;
                                    tempRows[idx].imagePath = res.data.content.ImagePath;
                                    tempRows[idx].imageRelativePath = res.data.content.ImageRelativePath;
                                    setDocumentUploadList(tempRows);
                                }
                            }
                        });
                })
                .catch(err => {
                    console.log(err);
                });

            reader.onloadend = () => {
                e.target.value = null;
            }

            reader.readAsDataURL(file)
        }
        else {
            e.target.value = null;
        }
    }

    const handleBtnUploadClick = async (e, idx) => {
        e.preventDefault();
        inputFile[idx].click();
        return false;
    }

    const CustomToastWithLink = () => (
        <div>
            <p>To add any documents that may support your plan e.g., water test reports, simply hit the + or Add button and then the green Upload icon. If you want to delete a document hit the red Trash icon.</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    const [imageViewPopup, setImageViewPopup] = useState({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    const handleImageViewPopup = (event, imageName, imageUrl) => {
        setImageViewPopup({ showImageViewPopup: true, imageName: imageName, imageUrl: imageUrl });
    }

    const handleImageViewPopupClose = (event) => {
        setImageViewPopup({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    }

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card>
                {showArrow && <CardHeader className="card-header-click" onClick={toggle}>
                    <Row>
                        <Col sm="11">
                            <h6>{header} &nbsp;&nbsp;&nbsp;</h6>
                        </Col>
                        <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                    </Row>
                </CardHeader>}
                <Collapse isOpen={isOpen}>
                    <CardBody>
                        {refid != 0 ?
                            <div>
                                <Row>
                                    <Col sm="12">
                                        <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                            <thead>
                                                <tr>
                                                    <th className="text-left" style={{ width: "15%" }}> Date</th>
                                                    <th className="text-left" style={{ width: "40%" }}> Description </th>
                                                    <th className="text-left" style={{ width: "40%" }}> Image </th>
                                                    <th style={{ textAlign: "center", width: "5%" }}>
                                                        {(roleName == 'Admin' || isAddEditItem   == 'true') &&
                                                            <>
                                                                <button style={{ width: "2vw" }} onClick={handleRecordRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse-light1">
                                                                    <FaPlus />
                                                                </button>
                                                            </>
                                                        }
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-left">
                                                {documentUploadList.map((item, idx) => (
                                                    <tr id="records" key={idx}>
                                                        <td style={{ display: "none" }}>{documentUploadList[idx].id}</td>
                                                        <td style={{ width: "15%" }}>
                                                            <DatePicker selected={documentUploadList[idx].uploadDate != null ? getDateFromString(moment(documentUploadList[idx].uploadDate).format("DD/MM/YYYY")) : null} onChange={(date) => handleDateChange(idx, date)} name="uploadDate" dateFormat="dd/MM/yyyy" className="form-control" />
                                                            {formErrors.length > 0 && formErrors[idx] != undefined && formErrors[idx].uploadDate != undefined &&
                                                                <p className="errorMessage">{formErrors[idx].uploadDate}</p>
                                                            }
                                                        </td>
                                                        <td style={{ width: "45%" }}>
                                                            <input type="textarea" name="imageDetail" value={documentUploadList[idx].imageDetail} onChange={handleDetailsChange(idx)} className="form-control" />
                                                            {formErrors.length > 0 && formErrors[idx] != undefined && formErrors[idx].imageDetail != undefined &&
                                                                <p className="errorMessage">{formErrors[idx].imageDetail}</p>
                                                            }
                                                        </td>
                                                        <td style={{ width: "15%" }}>
                                                            {documentUploadList[idx].imageRelativePath != null && documentUploadList[idx].imageRelativePath != '' ?
                                                                <Row>
                                                                    <Col>
                                                                        <img src={documentUploadList[idx].imageRelativePath} className="image-popup-thumbnail" alt={documentUploadList[idx].imageName}
                                                                            onClick={(event, imageName, imageUrl) => handleImageViewPopup(event, documentUploadList[idx].imageName, documentUploadList[idx].imageRelativePath)}></img>
                                                                    </Col>
                                                                    <Col>
                                                                        {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                                                            <>
                                                                                <Button style={{ float: `right` }} color="warning" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                            </>
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                                :
                                                                <>
                                                                    {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                                                        <>
                                                                            <Button style={{ float: `right` }} color="success" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                        </>
                                                                    }
                                                                </>
                                                            }
                                                            <br />
                                                            <input style={{ float: `right`, display: 'none' }}
                                                                ref={input => {
                                                                    inputFile[idx] = input;
                                                                }}
                                                                type="file" name="attachment" className="form-control" onChange={(e) => handleRecordChange(e, idx)} />
                                                            {formErrors.length > 0 && formErrors[idx] != undefined && formErrors[idx].fileError != undefined &&
                                                                <p className="errorMessage">{formErrors[idx].fileError}</p>
                                                            }
                                                        </td>
                                                        <td style={{ width: "5%" }}>
                                                            {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                                                <>
                                                                    <button style={{ float: "right" }} onClick={handleRecordRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                        <FaTrash />
                                                                    </button>
                                                                </>
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Col>
                                    <Col sm="12"> {refid != 0 ?
                                        showArrow &&
                                        <div>
                                                {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                                <>
                                                    {saving ?
                                                        <Button style={{ float: "right" }} onClick={handleRecordRowsSubmit} color="success" size="sm" disabled>
                                                            <Row>
                                                                <Col sm="8">
                                                                    <span>
                                                                        {' '}Saving
                                                                    </span>
                                                                </Col>
                                                                <Col sm="4">
                                                                    <Spinner size="sm">
                                                                        Saving...
                                                                    </Spinner>
                                                                </Col>
                                                            </Row>
                                                        </Button>
                                                        :
                                                        <Button color="success" size="sm" style={{ float: "right" }} onClick={handleRecordRowsSubmit}>
                                                            Save
                                                        </Button>
                                                    }
                                                </>
                                            }
                                        </div> : ''
                                    }
                                    </Col>
                                </Row>
                            </div> : <span>Please save to add Photo</span>}
                    </CardBody>
                </Collapse>
            </Card>


            <Modal isOpen={deleteDocumentPopup.showDeteteRecordPopup}>
                <ModalHeader toggle={handleRecordPopupClose} >Delete Record</ModalHeader>
                <ModalBody>
                    Do you want to delete the item ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={deleteRecord}>Yes</Button>
                    <Button color="danger" onClick={handleRecordPopupClose}>No</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={imageViewPopup.showImageViewPopup} size="lg" className="imageViewPopup">
                <ModalHeader toggle={handleImageViewPopupClose} >{imageViewPopup.imageName}</ModalHeader>
                <ModalBody>
                    <img src={imageViewPopup.imageUrl} className="item-image-popup" alt={imageViewPopup.imageName} ></img>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleImageViewPopupClose}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    )

}
export default PhotosWithDetails